// Module
var code = "<label data-toggle=\"tooltip\" data-placement=\"bottom\" data-bind=\"text: Name, tooltip: { content: Description ? Description : Name }\"></label> <input data-bind=\"textInput: Value, attr: { title: Value, disabled: Disabled, type: Type }\" class=\"form-control input-sm\" style=\"width:32%;max-width:215px;height:34px\"> ";
// Exports
export default code;